import * as React from 'react';
export default function EditBlockForm(props) {
    return (React.createElement("div", { className: "h-[80vh] flex flex-col gap-4 items-center justify-center rounded-lg bg-white border-2 border-dashed" }, "HERE WE WILL HAVE THE FORM"));
}
